import React from 'react'
import { useTranslation } from 'lib/i18n'

import Heading from 'components/Heading/Heading'
import useProfileInCollectionsCategories from 'hooks/useProfileInCollectionsCategories'

import { CategoryProps } from '../type'
import Category from './Category'

import styles from './Categories.module.css'

type CategoriesProps = {
  profileSlug: string
}

const Categories: React.FC<CategoriesProps> = ({ profileSlug }) => {
  const {
    loading,
    error,
    categories = [],
  } = useProfileInCollectionsCategories(profileSlug)
  const { t } = useTranslation()
  if (error || (loading && !categories?.length)) return null

  return (
    <div className={styles.categoriesWrapper}>
      <Heading level="h3" className={styles.heading}>
        <h3 className={styles.title}>
          {t('ProfilePage.Categories.heading', 'Related Categories')}
        </h3>
      </Heading>
      <nav className={styles.wrapper}>
        {categories.map((category: CategoryProps) => (
          <Category category={category} key={Math.random()} />
        ))}
      </nav>
    </div>
  )
}

export default Categories
